export const FULFILLMENT_API_CLIENT_NAME = 'fulfillment-api';
